import httpClientImmigration from "@/services/httpClientImmigration";
import { server } from "@/services/constants";

export const getPlaceofissue = () => {
  return httpClientImmigration.get(server.IM_MASTER_PLACE_OF_ISSUE);
};

export const getImMasterPlaceofissueByCompany = (query) => {
  return httpClientImmigration.get(
    server.IM_MASTER_PLACE_OF_ISSUE + `/getbycompany`,
    query,
  );
};

export const getImMasterPlaceofissueByDep = (dep_id) => {
  return httpClientImmigration.get(
    server.IM_MASTER_PLACE_OF_ISSUE + `/get-by-dep_id/${dep_id}`,
  );
};

export const getImMasterPlaceofissueByID = (id) => {
  return httpClientImmigration.get(
    server.IM_MASTER_PLACE_OF_ISSUE + `/get-by-id/${id}`,
  );
};

export const addImMasterPlaceofissue = (data) => {
  return httpClientImmigration.post(server.IM_MASTER_PLACE_OF_ISSUE, data);
};

export const UpdateImMasterPlaceofissue = (id, data) => {
  return httpClientImmigration.put(
    server.IM_MASTER_PLACE_OF_ISSUE + `/${id}`,
    data,
  );
};

export const DeleteImMasterPlaceofissue = (id) => {
  return httpClientImmigration.delete(
    server.IM_MASTER_PLACE_OF_ISSUE + `/${id}`,
  );
};

export const getImMasterPlaceofissueByCompany_Dep = (query) => {
  return httpClientImmigration.get(
    server.IM_MASTER_PLACE_OF_ISSUE + `/getbycompanyanddepartment`,
    query,
  );
};

export const getImMasterPlaceofissueByCompany_Dep_Pagination = (
  page,
  limit,
  sortBy,
  sortOrder,
  company_id,
  department_id,
  search,
) => {
  return httpClientImmigration.get(
    server.IM_MASTER_PLACE_OF_ISSUE + `/getbycompanyanddepartmentpagination`,
    {
      params: {
        page,
        limit,
        sortBy,
        sortOrder,
        company_id,
        department_id,
        search,
      },
    },
  );
};
